var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectedLaptop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.64,
    height: 37.92,
    viewBox: "0 0 46.64 37.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20736",
    "data-name": "Rectangle 20736",
    width: 46.64,
    height: 37.92,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31952",
    "data-name": "Group 31952",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22503",
    "data-name": "Path 22503",
    d: "M26.242,13.578a3.43,3.43,0,0,0-2.789,1.438L18.745,12.64a3.6,3.6,0,0,0,.045-2.275l4.744-2.392a3.416,3.416,0,1,0-.557-1.045l-4.722,2.38a3.63,3.63,0,1,0-.079,4.37l4.763,2.4a3.433,3.433,0,1,0,3.3-2.5m0-9.958a2.25,2.25,0,1,1-2.249,2.249,2.253,2.253,0,0,1,2.249-2.249M15.325,13.886a2.445,2.445,0,1,1,2.444-2.445,2.449,2.449,0,0,1-2.444,2.445m10.917,5.376a2.25,2.25,0,1,1,2.251-2.249,2.252,2.252,0,0,1-2.251,2.249",
    transform: "translate(2.114 0.44)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22504",
    "data-name": "Path 22504",
    d: "M41.274,23.93H3.94V0H41.274ZM6.3,21.569H38.913V2.362H6.3Z",
    transform: "translate(0.712 0)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22505",
    "data-name": "Path 22505",
    d: "M46.64,34.618H0V27.062l5.155-8.8H41.482l5.158,8.8ZM2.362,32.257H44.278V27.7l-4.149-7.075H6.511L2.362,27.7Z",
    transform: "translate(0 3.302)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20734",
    "data-name": "Rectangle 20734",
    width: 44.278,
    height: 2.362,
    transform: "translate(1.181 29.612)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20735",
    "data-name": "Rectangle 20735",
    width: 11.894,
    height: 2.362,
    transform: "translate(17.374 32.601)",
    fill: "#444"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedLaptop);
export default __webpack_public_path__ + "static/media/connected-laptop.e370b377f77f7b2ce6c48319b6bbc2c9.svg";
export { ForwardRef as ReactComponent };